import { initializeApp } from 'firebase/app'
import { getDatabase, ref } from 'firebase/database';
import { FirebaseConfig } from './keys';

const firebase = initializeApp(FirebaseConfig);

const isDev = process.env.NODE_ENV !== 'production';
const pathPrefix = isDev ? 'development/' : '';
export const withPrefix = (path) => pathPrefix + path;

export const database = getDatabase(firebase);
export const profileRef = ref(database, withPrefix('profile'));
export const projectsRef = ref(database, withPrefix('projects'));
export const educationRef = ref(database, withPrefix('education'));
export const skillsRef = ref(database, withPrefix('skills'));
export const experienceRef = ref(database, withPrefix('experience'));
export const achievementsRef = ref(database, withPrefix('achievements'));
export const messagesRef = ref(database, withPrefix('messages'));
export const visitsRef = ref(database, withPrefix('visits'));
// Newer, storage-optimized shape: one doc per browser session holding the
// heavy stuff (geo/device) once, with individual page views nested inside
// as lightweight {path, timestamp} entries. See actions/visitTracker.jsx.
export const visitSessionsRef = ref(database, withPrefix('visitSessions'));
export const tetrisGameScoreRef = ref(database, withPrefix('tetrisGameScores'));
export const whackamoleGameScoreRef = ref(database, withPrefix('whackamoleGameScores'));
export const snakeGameScoreRef = ref(database, withPrefix('snakeGameScores'));
export const d2048GameScoreRef = ref(database, withPrefix('2048GameScores'));

export default firebase;